<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <span v-if="this.kolicinaVina > 0"
            >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
            {{ this.jm_mark }}</span
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 pa-2>
          <v-autocomplete
            ref="element1"
            v-model="tank_to_select"
            :items="tank_to_items"
            item-value="tankPhaseWineId"
            item-text="name"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Tank iz kog se doliva"
            required
            persistent-hint
            return-object
            v-on:change="changeRoute"
            :disabled="!edit"
          >
            <template slot="selection" slot-scope="data">
              <template v-if="data.item.phaseMark === null"
                >{{ data.item.name }} / (prazan tank)</template
              >
              <template v-else-if="data.item.tankPhaseWineId === 0"
                >Izaberite tank</template
              >
              <template v-else
                >{{ data.item.name }} / {{ data.item.phaseMark }} / Ostalo
                {{ data.item.currentQuantity }}</template
              >
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="data.item.phaseMark === null"
                >{{ data.item.name }} / (prazan tank)</template
              >
              <template v-else-if="data.item.tankPhaseWineId === 0"
                >Izaberite tank</template
              >
              <template v-else
                >{{ data.item.name }} / {{ data.item.phaseMark }} / Ostalo
                {{ data.item.currentQuantity }}</template
              >
            </template>
          </v-autocomplete>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              use-seconds="false"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="wine_quantity"
            ref="element2"
            label="Količina"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_dolivanja_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            ref="element3"
            :disabled="!edit"
          ></v-select>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-text-field
            v-model="sediment_quantity"
            ref="element4"
            :label="tekst_labele_1"
            type="number"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_sediment_select"
            :items="jm_sediment_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
            ref="element5"
            :disabled="!edit"
          ></v-select>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-text-field
            v-model="outage_quantity"
            ref="element6"
            label="Rastur"
            type="number"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_outage_select"
            :items="jm_outage_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
            ref="element7"
            :disabled="!edit"
          ></v-select>
        </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            ref="element8"
            label="Opis"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn
            :disabled="!valid"
            @click="submit"
            class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            >odustani</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "FillingItem",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: "0",
    opis: "",
    tank_to_items: [],
    tank_to_select: undefined,
    vineyard_grape_variety_items: [],
    jm_dolivanja_select: "",
    jm_outage_select: "",
    vineyard_grape_variety_select: "",
    date: null, //For datepicker
    menu: "",
    entry_date: null, //For datepicker
    entry_menu: "",
    wine_quantity: 0,
    jm_items: [],
    outage_quantity: 0,
    jm_outage_items: [],
    id_tank_phase_wine: 0,
    id_tank: 0,
    id_tank_phase_wine_blend: 0,
    kolicinaVina: 0,
    preostalo_izabrani_tank: 0,
    isEmptyTank: false,
    tip_vina_tank: 0,
    sediment_quantity: 0,
    jm_sediment_items: [],
    jm_sediment_select: "",
    time: undefined,
    menu1: "",
    faza_mark: "",
    tank_to_select_name_stara: "",
    tank_to_items_init: [],
    jm_mark: "",

    date: null,
    dateFormatted: null,
    tekst_labele_1: "",
    edit: true,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      if (this.tank_to_select !== undefined) {
        let kolicinaVina = Number(this.kolicinaVina);
        let wine_quantity = Number(this.wine_quantity);

        if (typeof this.outage_quantity === "undefined")
          this.outage_quantity = 0;
        if (typeof this.sediment_quantity === "undefined")
          this.sediment_quantity = 0;

        let outage_quantity = Number(this.outage_quantity);
        let sediment_quantity = Number(this.sediment_quantity);

        let preostalo_izabrani_tank = Number(this.preostalo_izabrani_tank);

        if (Number(wine_quantity) === 0) {
          this.isLoading = false;
          alert("Uneta količina ne sme imati vrednost nula.");
        } else if (this.isEmptyTank) {
          this.isLoading = false;
          alert("Izabrani tank je prazan");
        } else {
          var complexObjectTankFrom = {
            id: this.tank_to_select.tankPhaseWineId,
          };

          var complexObjectTankTo = {
            id: this.id_tank_phase_wine,
          };

          var complexObjectUnitOfMeasure;

          if (
            typeof this.jm_dolivanja_select !== "undefined" &&
            this.jm_dolivanja_select !== ""
          )
            if (typeof this.jm_dolivanja_select.id !== "undefined")
              complexObjectUnitOfMeasure = {
                id: this.jm_dolivanja_select.id,
              };
            else
              complexObjectUnitOfMeasure = {
                id: this.jm_dolivanja_select,
              };

          var complexObjectUnitOfMeasureSediment;

          if (
            typeof this.jm_sediment_select !== "undefined" &&
            this.jm_sediment_select !== ""
          )
            if (typeof this.jm_sediment_select.id !== "undefined")
              complexObjectUnitOfMeasureSediment = {
                id: this.jm_sediment_select.id,
              };
            else
              complexObjectUnitOfMeasureSediment = {
                id: this.jm_sediment_select,
              };

          var complexObjectUnitOfMeasureOutage;

          if (
            typeof this.jm_outage_select !== "undefined" &&
            this.jm_outage_select !== ""
          )
            complexObjectUnitOfMeasureOutage = {
              id: this.jm_outage_select.id,
            };
          var complexObject;

          if (
            typeof this.outage_quantity !== "undefined" &&
            this.outage_quantity !== ""
          )
            if (
              typeof this.sediment_quantity !== "undefined" &&
              this.sediment_quantity !== ""
            )
              complexObject = {
                fromTankPhaseWine: complexObjectTankFrom,
                toTankPhaseWine: complexObjectTankTo,
                quantity: this.wine_quantity,
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                outage: this.outage_quantity,
                outageUnitOfMeasure: complexObjectUnitOfMeasureOutage,
                sediment: this.sediment_quantity,
                sedimentUnitOfMeasure: complexObjectUnitOfMeasureSediment,
                date: this.date + "T" + this.time,
                description: this.opis,
              };
            else
              complexObject = {
                fromTankPhaseWine: complexObjectTankFrom,
                toTankPhaseWine: complexObjectTankTo,
                quantity: this.wine_quantity,
                outage: this.outage_quantity,
                quantityUnitOfMeasure: complexObjectUnitOfMeasure,
                outageUnitOfMeasure: complexObjectUnitOfMeasureOutage,
                date: this.date + "T" + this.time,
                description: this.opis,
              };
          else if (
            typeof this.sediment_quantity !== "undefined" &&
            this.sediment_quantity !== ""
          )
            complexObject = {
              fromTankPhaseWine: complexObjectTankFrom,
              toTankPhaseWine: complexObjectTankTo,
              quantity: this.wine_quantity,
              quantityUnitOfMeasure: complexObjectUnitOfMeasure,
              sediment: this.sediment_quantity,
              sedimentUnitOfMeasure: complexObjectUnitOfMeasureSediment,
              date: this.date + "T" + this.time,
              description: this.opis,
            };
          else
            complexObject = {
              fromTankPhaseWine: complexObjectTankFrom,
              toTankPhaseWine: complexObjectTankTo,
              quantity: this.wine_quantity,
              quantityUnitOfMeasure: complexObjectUnitOfMeasure,
              date: this.date + "T" + this.time,
              description: this.opis,
            };

          // // console.log(JSON.stringify(complexObject));

          this.$http
            .post(
              this.globalServiceLocation + this.globalPort + "/filling/create",
              complexObject,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              this.isLoading = false;

              if (this.id_tank_phase_wine == 0) {
                this.id_tank_phase_wine = response.data.id;
              }

              this.clear();

              serverBus.$emit("refresh_filling", this.id_tank_phase_wine);
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                this.isLoading = false;

                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .post(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/filling/create",
                          complexObject,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          this.isLoading = false;

                          if (this.id_tank_phase_wine == 0) {
                            this.id_tank_phase_wine = response.data.id;
                          }

                          this.clear();

                          serverBus.$emit(
                            "refresh_filling",
                            this.id_tank_phase_wine
                          );
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
      }
    },
    PreostaloUTanku(idTank) {
      if (typeof idTank !== "undefined" && typeof idTank !== "object" && idTank !== 0)
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(idTank);
            // // console.log(response.data);

            this.preostalo_izabrani_tank =
              response.data.tankCapacity - response.data.freeSpaceInTank;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(idTank);
                        // // console.log(response.data);

                        this.preostalo_izabrani_tank =
                          response.data.tankCapacity -
                          response.data.freeSpaceInTank;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    changeRoute(a) {
      // console.log(a);
      

      if (typeof a !== "undefined") {
        // // // console.log(a.id);
        if (a.id === undefined) {
          if (a !== undefined) {
            if (a.name !== undefined) {
              let enumLable = this.tank_to_items.find(
                (x) => x.tankPhaseWineId === a
              ).enumLable;

              if (enumLable === "press") this.tekst_labele_1 = "Komina";
              else this.tekst_labele_1 = "Taloga";
            } else this.tekst_labele_1 = "Taloga";
          }
        } else {
          //this.wine_quantity = "undefined";

          this.PreostaloUTanku(a.id);
          let enumLable = this.tank_to_items.find(
            (x) => x.id === a.id
          ).enumLable;

          if (enumLable === "press") this.tekst_labele_1 = "Komina";
          else this.tekst_labele_1 = "Taloga";
        }
      }
    },
    changeSifarnik() {
      let kolicinaVina = Number(this.kolicinaVina);
      let wine_quantity = Number(this.wine_quantity);

      if (typeof this.outage_quantity === "undefined") this.outage_quantity = 0;
      if (typeof this.sediment_quantity === "undefined")
        this.sediment_quantity = 0;

      let outage_quantity = Number(this.outage_quantity);
      let sediment_quantity = Number(this.sediment_quantity);

      let preostalo_izabrani_tank = Number(this.preostalo_izabrani_tank);

      if (Number(wine_quantity) === 0) {
        this.isLoading = false;
        alert("Uneta količina ne sme imati vrednost nula.");
      } else if (this.isEmptyTank) {
        this.isLoading = false;
        alert("Izabrani tank je prazan");
      } else {
        var complexObjectTankFrom;

        if (typeof this.tank_to_select.tankPhaseWineId !== "undefined")
          complexObjectTankFrom = {
            id: this.tank_to_select.tankPhaseWineId,
          };
        else
          complexObjectTankFrom = {
            id: this.tank_to_select,
          };

        var complexObjectTankTo = {
          id: this.id_tank_phase_wine,
        };

        var complexObjectUnitOfMeasure;

        if (
          typeof this.jm_dolivanja_select !== "undefined" &&
          this.jm_dolivanja_select !== ""
        )
          if (typeof this.jm_dolivanja_select.id !== "undefined")
            complexObjectUnitOfMeasure = {
              id: this.jm_dolivanja_select.id,
            };
          else
            complexObjectUnitOfMeasure = {
              id: this.jm_dolivanja_select,
            };

        var complexObjectUnitOfMeasureSediment;

        if (
          typeof this.jm_sediment_select !== "undefined" &&
          this.jm_sediment_select !== ""
        )
          if (typeof this.jm_sediment_select.id !== "undefined")
            complexObjectUnitOfMeasureSediment = {
              id: this.jm_sediment_select.id,
            };
          else
            complexObjectUnitOfMeasureSediment = {
              id: this.jm_sediment_select,
            };

        var complexObjectUnitOfMeasureOutage;

        // if (
        //   typeof this.jm_outage_select !== "undefined" &&
        //   this.jm_outage_select !== ""
        // )
        //   complexObjectUnitOfMeasureOutage = {
        //     id: this.jm_outage_select.id
        //   };

        if (
          typeof this.jm_outage_select !== "undefined" &&
          this.jm_outage_select !== ""
        )
          if (typeof this.jm_outage_select.id !== "undefined")
            complexObjectUnitOfMeasureOutage = {
              id: this.jm_outage_select.id,
            };
          else
            complexObjectUnitOfMeasureOutage = {
              id: this.jm_outage_select,
            };

        var complexObject;

        if (
          typeof this.outage_quantity !== "undefined" &&
          this.outage_quantity !== ""
        )
          if (
            typeof this.sediment_quantity !== "undefined" &&
            this.sediment_quantity !== ""
          )
            complexObject = {
              id: this.ID,
              fromTankPhaseWine: complexObjectTankFrom,
              toTankPhaseWine: complexObjectTankTo,
              quantity: this.wine_quantity,
              quantityUnitOfMeasure: complexObjectUnitOfMeasure,
              outage: this.outage_quantity,
              outageUnitOfMeasure: complexObjectUnitOfMeasureOutage,
              sediment: this.sediment_quantity,
              sedimentUnitOfMeasure: complexObjectUnitOfMeasureSediment,
              date: this.date + "T" + this.time,
              description: this.opis,
            };
          else
            complexObject = {
              id: this.ID,
              fromTankPhaseWine: complexObjectTankFrom,
              toTankPhaseWine: complexObjectTankTo,
              quantity: this.wine_quantity,
              outage: this.outage_quantity,
              quantityUnitOfMeasure: complexObjectUnitOfMeasure,
              outageUnitOfMeasure: complexObjectUnitOfMeasureOutage,
              date: this.date + "T" + this.time,
              description: this.opis,
            };
        else if (
          typeof this.sediment_quantity !== "undefined" &&
          this.sediment_quantity !== ""
        )
          complexObject = {
            id: this.ID,
            fromTankPhaseWine: complexObjectTankFrom,
            toTankPhaseWine: complexObjectTankTo,
            quantity: this.wine_quantity,
            quantityUnitOfMeasure: complexObjectUnitOfMeasure,
            sediment: this.sediment_quantity,
            sedimentUnitOfMeasure: complexObjectUnitOfMeasureSediment,
            date: this.date + "T" + this.time,
            description: this.opis,
          };
        else
          complexObject = {
            id: this.ID,
            fromTankPhaseWine: complexObjectTankFrom,
            toTankPhaseWine: complexObjectTankTo,
            quantity: this.wine_quantity,
            quantityUnitOfMeasure: complexObjectUnitOfMeasure,
            date: this.date + "T" + this.time,
            description: this.opis,
          };

        // // console.log(JSON.stringify(complexObject));

        this.$http
          .put(
            this.globalServiceLocation + this.globalPort + "/filling/update",
            complexObject,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.isLoading = false;

            serverBus.$emit("refresh_filling", this.id_tank_phase_wine);

            this.clear();
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              this.isLoading = false;

              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .put(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/filling/update",
                        complexObject,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.isLoading = false;

                        serverBus.$emit(
                          "refresh_filling",
                          this.id_tank_phase_wine
                        );

                        this.clear();
                      })
                      .catch((e) => {
                        this.isLoading = false;

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllTankovi(svi) {
      let tipVinaPom = 0;

      if (svi === false) tipVinaPom = this.tip_vina_tank;

      

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/filling/" +
            this.id_tank +
            "/" +
            tipVinaPom +
            "/" +
            this.faza,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.tank_to_items_init = response.data;
          this.tank_to_items_init.splice(0, 0, {
            tankPhaseWineId: 0,
            name: undefined,
            phaseMark: undefined,
          });

          this.tank_to_items = this.tank_to_items_init;

          if (this.tank_id !== 0) this.tank_to_select = this.tank_id;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/filling/" +
                        this.id_tank +
                        "/" +
                        this.tip_vina_tank +
                        "/" +
                        this.faza,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.tank_to_items_init = response.data;
                      this.tank_to_items_init.splice(0, 0, {
                        tankPhaseWineId: 0,
                        name: undefined,
                        phaseMark: undefined,
                      });

                      this.tank_to_items = this.tank_to_items_init;

                      if (this.tank_id !== 0)
                        this.tank_to_select = this.tank_id;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (
          this.$refs.element1.validate() &&
          this.tank_to_select.tankPhaseWineId != 0
        ) {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") this.changeSifarnik();
            else this.newSifarnik();

            // this.isLoading = false;
          }, 1000);
        } else alert("Niste odabrali tank iz kog se doliva.");
      }
    },
    clear() {
      // this.$refs.form.reset();

      this.$refs.element1.reset();
      this.$refs.element2.reset();
      this.$refs.element3.reset();
      this.$refs.element4.reset();
      this.$refs.element5.reset();
      this.$refs.element6.reset();
      this.$refs.element7.reset();
      this.$refs.element8.reset();

      this.ID = 0;
      this.tekst_labele_1 = "Taloga";
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let niz = [];
          let litar;

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);

            if (entry.mark === "l") litar = entry;
          });

          this.jm_items = niz;
          this.jm_outage_items = niz;
          this.jm_sediment_items = niz;

          this.jm_dolivanja_select = litar;
          this.jm_outage_select = litar;
          this.jm_sediment_select = litar;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];
                      let litar;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);

                        if (entry.mark === "l") litar = entry;
                      });

                      this.jm_items = niz;
                      this.jm_outage_items = niz;
                      this.jm_sediment_items = niz;

                      this.jm_dolivanja_select = litar;
                      this.jm_outage_select = litar;
                      this.jm_sediment_select = litar;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    this.clear();
    this.setTime();
    this.setDate();

    this.getAllJediniceMere();

    serverBus.$on("applied_filling", (item) => {
      console.log(item);

      // this.id_tank_phase_wine_blend = item.tankPhaseWineBlendId;
      this.ID = item.id;
      this.tip_vina_tank = Number(item.wineId);

      // this.vineyard_grape_variety_select = item.fillingDto.vineyardGrapeVariety.id;
      // this.date = item.date;

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      // this.entry_date = item.fillingDto.entryDate;
      this.wine_quantity = item.quantity;
      this.jm_dolivanja_select = item.quantityUnitOfMeasure.id;

      if (item.outageUnitOfMeasure !== null) {
        this.outage_quantity = item.outage;
        this.jm_outage_select = item.outageUnitOfMeasure.id;
      }

      if (item.sedimentUnitOfMeasure !== null) {
        this.sediment_quantity = item.sediment;
        this.jm_sediment_select = item.sedimentUnitOfMeasure.id;
      }

      this.opis = item.description;

      let addNew = false;

      let duzinaNiza = this.tank_to_items_init.length;

      for (var i = 0; i < duzinaNiza; i++) {
        if (
          this.tank_to_items_init[i].tankPhaseWineId ===
          item.fromTankPhaseWine.id
        )
          addNew = true;
        this.tank_to_items.push(this.tank_to_items_init[i]);
      }

      if (!addNew) {
        let phaseName = "";

        if (item.phaseName === "Alkoholna fermentacija") phaseName = "AF";
        else if (item.phaseName === "Malolaktička fermentacija")
          phaseName = "MF";
        else if (item.phaseName === "Alkoholna malolaktička fermentacija")
          phaseName = "AM";
        else if (item.phaseName === "Odležavanje") phaseName = "OD";
        else phaseName = "ZA";

        this.tank_to_items.splice(1, 0, {
          tankPhaseWineId: item.fromTankPhaseWine.id,
          name: item.fromTankPhaseWine.tank.name,
          phaseMark: phaseName,
        });
      }

      this.PreostaloUTanku(item.fromTankPhaseWine.tank.id);

      // // console.log(this.tank_to_items);

      // this.tank_to_select = item.fromTankPhaseWine.id;
      this.tank_to_select_name_stara = item.fromTankPhaseWine.tank.name;
      this.tank_id = item.fromTankPhaseWine.id;

      if (this.tank_to_select === undefined)
        this.tank_to_select = item.fromTankPhaseWine.id;
    });

    serverBus.$on(
      "filling",
      (
        id_tank_phase_wine,
        id_tank,
        kolicina_vina,
        faza,
        tip_vina,
        vino_id,
        faza_mark,
        jm_mark,
        tank_type,
        edit
      ) => {
        // alert("filling");

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        // // console.log(id_tank_phase_wine);

        this.id_tank_phase_wine = id_tank_phase_wine;
        this.id_tank = id_tank;
        this.kolicinaVina = kolicina_vina;

        this.faza = faza;
        this.tipVina = tip_vina;
        this.tip_vina_tank = Number(vino_id);

        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        this.getAllTankovi(false);

        // if (tank_type === "press")
        //   this.tekst_labele_1 = "Komina";
        // else
        this.tekst_labele_1 = "Taloga";
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.fillingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
